<div class="document-viewer-container">

    <myapp-privacy *ngIf="documentType === DocumentType.PrivacyPolicy"></myapp-privacy>
    <myapp-terms *ngIf="documentType === DocumentType.TermsOfService"></myapp-terms>
    <myapp-faq *ngIf="documentType === DocumentType.FAQ"></myapp-faq>

</div>
